import React, { Component, PropTypes } from 'react';

import { Deck, Slide } from 'spectacle-ppa';

import MarkdownScript from 'helpers/markdownScript';
import markdownFile from './index.md';


import start from './sections/01_start/startSection';
import song from './sections/03_song/songSection';
import missionReport from
  './sections/11_missionReport/missionReportSection';
import esOpeningStory from './sections/12_esOpeningStory/esOpeningStorySection';
import gameShow from './sections/20_gameShow/gameShowSection';
import classActivity from './sections/30_classActivity/classActivitySection';
import esClosingStory from './sections/60_esClosingStory/esClosingStorySection';
import missionAssignment from
  './sections/70_missionAssignment/missionAssignmentSection';
import finish from './sections/90_finish/finishSection';

import Hacked from 'components/hacked';

const md = new MarkdownScript(markdownFile);
const level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
const title = md.getSectionMetadata(`Level ${level}`, 'Title');

export default class extends Component {

  static contextTypes = {
    regionData: PropTypes.object.isRequired
  };

  static metadata = {
    title
  };

  render() {
    const { regionData } = this.context;
    return (
      <Deck transition={['slide']}
            transitionDuration={800}
            progress="bar">

        {/* Hacked */}
        <Slide
            id="hacked"
            notes={'<h2>Level ' + level + ' Hacked</h2>'}
            bgColor="black"
            key="start"
            hacked>
          <Hacked />
        </Slide>

        {/* Start */}
        {start({ level, title, regionData })}

        {/* Esmeralda Opening Story */}
        {esOpeningStory({ level, regionData })}

        {/* Mission Report */}
        {missionReport({ level, regionData })}

        {/* Theme Song */}
        {song({ level, regionData })}

        {/* Game Show */}
        {gameShow({ level, regionData })}

        {/* Class Activity: Buy Smart Code */}
        {classActivity({ level, subActivity: 'a', regionData })}

        {/* Class Activity: Skit */}
        {classActivity({ level, subActivity: 'b', regionData })}

        {/* Esmeralda Closing Story */}
        {esClosingStory({ level, regionData })}

        {/* Mission Assignment */}
        {missionAssignment({ level, title, regionData })}

        {/* Finish */}
        {finish({ level, regionData })}

      </Deck>
    );
  }

}



// WEBPACK FOOTER //
// ./programs/zeroHeroes/level5.jsx